var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIconOfficial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2402 11.2467H13.8669C12.286 11.2467 10.9994 9.96089 10.9985 8.38089C10.9985 6.79922 12.2852 5.51255 13.8669 5.51172H17.2402C17.5852 5.51172 17.8652 5.79172 17.8652 6.13672C17.8652 6.48172 17.5852 6.76172 17.2402 6.76172H13.8669C12.9744 6.76255 12.2485 7.48839 12.2485 8.38005C12.2485 9.27089 12.9752 9.99672 13.8669 9.99672H17.2402C17.5852 9.99672 17.8652 10.2767 17.8652 10.6217C17.8652 10.9667 17.5852 11.2467 17.2402 11.2467Z",
    fill: "#00948B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2483 8.95312H13.9883C13.6433 8.95312 13.3633 8.67312 13.3633 8.32812C13.3633 7.98313 13.6433 7.70312 13.9883 7.70312H14.2483C14.5933 7.70312 14.8733 7.98313 14.8733 8.32812C14.8733 8.67312 14.5933 8.95312 14.2483 8.95312Z",
    fill: "#00948B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1199_3873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 0.5H17.8653V16.4774H0.666504V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1199_3873)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66435 1.75C3.59768 1.75 1.91602 3.43167 1.91602 5.49833V11.4792C1.91602 13.5458 3.59768 15.2275 5.66435 15.2275H12.8677C14.9343 15.2275 16.6152 13.5458 16.6152 11.4792V5.49833C16.6152 3.43167 14.9343 1.75 12.8677 1.75H5.66435ZM12.8677 16.4775H5.66435C2.90852 16.4775 0.666016 14.235 0.666016 11.4792V5.49833C0.666016 2.74167 2.90852 0.5 5.66435 0.5H12.8677C15.6235 0.5 17.8652 2.74167 17.8652 5.49833V11.4792C17.8652 14.235 15.6235 16.4775 12.8677 16.4775Z",
    fill: "#00948B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57046 5.53125H5.07129C4.72629 5.53125 4.44629 5.25125 4.44629 4.90625C4.44629 4.56125 4.72629 4.28125 5.07129 4.28125H9.57046C9.91546 4.28125 10.1955 4.56125 10.1955 4.90625C10.1955 5.25125 9.91546 5.53125 9.57046 5.53125Z",
    fill: "#00948B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIconOfficial);
export default __webpack_public_path__ + "static/media/wallet-icon-official.4578d128a6a700dc97a927d4765b7ec4.svg";
export { ForwardRef as ReactComponent };